import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {BranchOffice, branchOfficeFiltering, branchOfficeInput, serviceOfficeInput} from './branch-office.model';

export const loadBranchOffices = createAction(
  '[BranchOffice/API] Load BranchOffices',
  props<{ branchOffices: BranchOffice[] }>()
);

export const addBranchOffice = createAction(
  '[BranchOffice/API] Add BranchOffice',
  props<{ branchOffice: BranchOffice }>()
);

export const upsertBranchOffice = createAction(
  '[BranchOffice/API] Upsert BranchOffice',
  props<{ branchOffice: BranchOffice }>()
);

export const addBranchOffices = createAction(
  '[BranchOffice/API] Add BranchOffices',
  props<{ branchOffices: BranchOffice[] }>()
);

export const upsertBranchOffices = createAction(
  '[BranchOffice/API] Upsert BranchOffices',
  props<{ branchOffices: BranchOffice[] }>()
);

export const updateBranchOffice = createAction(
  '[BranchOffice/API] Update BranchOffice',
  props<{ branchOffice: Update<BranchOffice> }>()
);

export const updateBranchOffices = createAction(
  '[BranchOffice/API] Update BranchOffices',
  props<{ branchOffices: Update<BranchOffice>[] }>()
);

export const deleteBranchOffice = createAction(
  '[BranchOffice/API] Delete BranchOffice',
  props<{ id: string }>()
);

export const deleteBranchOffices = createAction(
  '[BranchOffice/API] Delete BranchOffices',
  props<{ ids: string[] }>()
);

export const clearBranchOffices = createAction(
  '[BranchOffice/API] Clear BranchOffices'
);


// CUSTOM

export const createInstitutionOfficeBranchMutation = createAction(
  '[BranchOffice/API] create Institution Office BranchMutation',
  props<{ branchOffice: branchOfficeInput }>()
);

export const updateInstitutionOfficeBranchMutation = createAction(
  '[BranchOffice/API] update Institution Office BranchMutation',
  props<{ branchOffice: branchOfficeInput }>()
);

export const deleteInstitutionOfficeBranchMutation = createAction(
  '[BranchOffice/API] delete Institution Office Branch Mutation',
  props<{ officeUniqueId: string ,id?:string}>()
);

export const getAllOfficeBranch = createAction(
  '[BranchOffice/API] Get All OfficeBranch',
  props<{filtering: branchOfficeFiltering}>()
);



